var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"leftsidebar__model-link"},[_c('router-link',{attrs:{"to":{name: 'model', params: {name: _vm.name}}}},[_c('p',{class:{
				'leftsidebar--active': _vm.active,
				'hidden-phone': !this.$store.state.app.sidebars.left,
			}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }